import { createStore } from "vuex";

const store = createStore({
  state: {
    token: null,
    user: null,

    
    cases: [],
    payments:[],
   
    members:[],
    // newMembers:[],
    mpesaPayments:[],
    expenses:[],

    
  },
  mutations: {
    clearToken(context) {
      context.commit("removeToken");
    },
    clearUser(context) {
      context.commit("removeUser");
    },
    addToken(context) {
      context.commit("setToken");
    },

    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
    },
    removeToken(state) {
      state.token = null;
    },
    removeUser(state) {
      state.user = null;
    },
    setExpenses(state,expenses) {
      state.expenses = expenses;
    },

    
    
    
    
    setPayments(state, payments) {
      state.payments = payments;
    },
    setMpesapayments(state, mpesaPayments) {
      state.mpesaPayments = mpesaPayments;
    },
    setMembers(state, members){
      state.members=members
    },
    // setNewmembers(state, newMembers){
    //   state.newMembers=newMembers
    // },

    setCases(state, cases){
      state.cases=cases
    }
    
    


   
  },
  actions: {
    clearToken(context) {
      context.commit("removeToken");
    },
    clearUser(context) {
      context.commit("removeUser");
    },
    addToken(context) {
      context.commit("setToken");
    },

    



    async LoadPayments(context) {
      const url = `https://api.roberms.com/shangilia/get/payments`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      console.log(responseData);
      const payments = [];

      for (const key in responseData) {
        const payment = {
          id: key,
          member_id: responseData[key].member_id,
          member_name: responseData[key].member_name,
          case_id: responseData[key].case_id,
          amount: responseData[key].amount,
          payment_date: responseData[key].payment_date,
          paid_by: responseData[key].paid_by,
          reference: responseData[key].payment_reference,
        };
        payments.push(payment);
      }
      context.commit("setPayments", payments);
    },

    async LoadMembers(context) {
      const url = `https://api.roberms.com/itibo/get/members`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      console.log(responseData);
      const members = [];

      for (const key in responseData) {
        const member = {
          id: key,
          member_id: responseData[key].member_id,
          member_name: responseData[key].member_name,
          member_phone: responseData[key].member_phone,

          registration_amount: responseData[key].registration_amount,
          buffer_amount: responseData[key].buffer_amount,
          previous_balance: responseData[key].previous_balance,
          
          Jan: responseData[key].Jan,
          Feb: responseData[key].Feb,
          Mar: responseData[key].Mar,
          Apr: responseData[key].Apr,
          May: responseData[key].May,
          Jun: responseData[key].Jun,
          Jul: responseData[key].Jul,
          Aug: responseData[key].Aug,
          Sep: responseData[key].Sep,
          Oct: responseData[key].Oct,
          Nov: responseData[key].Nov,
          Dec: responseData[key].Dec,
          // case_14_amount: responseData[key].case_14,
          // case_15_amount: responseData[key].case_15,
          wallet_amount: responseData[key].wallet_amount,
          total: responseData[key].total,


          payment_date: responseData[key].payment_date,
          paid_by: responseData[key].paid_by,
          // processed_by: responseData[key].processed_by,
          reference: responseData[key].reference,
          processed: responseData[key].processed,
        };
        members.push(member);
      }
      context.commit("setMembers", members);
    },
    async LoadMpesapayments(context) {
      const url = `https://api.roberms.com/itibo/get/mpesa/payments`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      console.log(responseData);
      const MpesaPayments = [];

      for (const key in responseData) {
        const payment = {
          id: key,

          FirstName: responseData[key].firstName,
          TransID: responseData[key].transactionID,
          TransAmount: responseData[key].transactionAmt,
          payment_date: responseData[key].timestamp,
          account_number: responseData[key].debitMSISDN,
          payment_reference: responseData[key].payment_reference,
          OrgAccountBalance:responseData[key].OrgAccountBalance,
          processed: responseData[key].processed,
        };
        MpesaPayments.push(payment);
      }
      context.commit("setMpesapayments", MpesaPayments);
    },

    async LoadExpenses(context) {
      const url = `https://api.roberms.com/itibo/get/expenses`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      console.log(responseData);
      const expenses = [];

      for (const key in responseData) {
        const expense = {
          id: key,

          item: responseData[key].item,
          description: responseData[key].description,
          amount: responseData[key].amount,
          paid_to: responseData[key].paid_to,
          expense_date: responseData[key].expense_date,
          processed: responseData[key].processed,
          reference: responseData[key].reference,
        };
        expenses.push(expense);
      }
      context.commit("setExpenses", expenses);
    },

    async LoadCases(context) {
      const url = `https://api.roberms.com/itibo/get/cases`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      console.log(responseData);
      const cases = [];

      for (const key in responseData) {
        const casse = {
          id: key,

          case_id: responseData[key].id,
          member_id: responseData[key].member_id,
          Member_name: responseData[key].Member_name,
          dependant_name: responseData[key].dependant_name,
          relationship: responseData[key].relationship,
          Amount_disbursed: responseData[key].Amount_disbursed,
          members_contribution: responseData[key].members_contribution,
          payment_date:responseData[key].payment_date,
          processed: responseData[key].processed,

          
          date: responseData[key].disbursement_date,
          // reference: responseData[key].payment_reference,
          // processed: responseData[key].processed,
        };
        cases.push(casse);
      }
      context.commit("setCases", cases);
    },
  
  
  
  

   
  
  },
  getters: {
    isLoggedIn() {
      return !!localStorage.getItem("token");
    },

   
    
    members: (state) => state.members,
    cases:(state)=>state.cases,
    expenses:(state)=> state.expenses,
    // members: (state) => state.members,
    newmembers: (state)=>state.newMembers,
    allPayments: (state) => state.payments,
    allcases: (state) => state.cases,
    membercasePayments: (state)=> (mid) => state.payments.filter(vnumber=>vnumber.case_id==mid),
    allMembers: (state) => state.members,
    memberdetails: (state) => (mid)=>state.members.filter(vnumber=>vnumber.member_idNumber==mid),

    joiningMember: (state) =>(mid)=>state.newMembers.filter(vnumber=>vnumber.member_id==mid),
    mpesaPayments: (state)=>state.mpesaPayments,
    

    voterGetter: (state)=>(vid)=>state.voters.filter(vnumber=>vnumber.id_number==vid),

   casedetails: (state) => (cid)=>state.cases.filter(vnumber=>vnumber.id==cid),


  },


  //
});
export default store;